import type { LoaderFunction } from "react-router-dom";

const profilePasswordLoader: LoaderFunction = async () => {
  // No data loading needed for password reset page
  return null;
};

export default profilePasswordLoader;
